/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tracks_SubInputs */

const en_cp_tracks_sub = /** @type {(inputs: Cp_Tracks_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder and Problem Solver share one flow: PRD → task → build → verify → evidence → approve. Only the starting point and the finale differ.`)
};

const id_cp_tracks_sub = /** @type {(inputs: Cp_Tracks_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder dan Problem Solver memakai alur yang sama: PRD → task → kerjakan → verifikasi → bukti → setujui. Yang berbeda hanya titik mulai dan puncaknya.`)
};

/**
* | output |
* | --- |
* | "Builder and Problem Solver share one flow: PRD → task → build → verify → evidence → approve. Only the starting point and the finale differ." |
*
* @param {Cp_Tracks_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tracks_sub = /** @type {((inputs?: Cp_Tracks_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tracks_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tracks_sub(inputs)
	return en_cp_tracks_sub(inputs)
});